<lib-sticky-modal>
  <lib-sticky-header [stickyCollectionKey]="'template-view-locations'" [stickyZ]="stickyZ" [stickyOrder]="0">
    <div class="modal-header no-bottom-border" fxLayout="row" fxLayoutAlign="space-between center">
      <div class="modal-title" ngbAutofocus>
        {{ viewModel.province$ | async }}
      </div>
    </div>
  </lib-sticky-header>
  <lib-sticky-body>
    <div
      #contentContainer
      libStickyAutoPosition
      [stickyCollectionKey]="'template-view-locations'"
      [stickyZ]="stickyZ"
      [stickyOrder]="1">
      <div class="desc-and-search pb-16px" fxLayout="column" [style.gap.rem]="1">
        <app-message-banner>
          All locations marked as required will automatically create this templated menu. If a location is not required
          and the templated menu already exists at that location, it will not be deleted.
        </app-message-banner>
        <div class="asterisk-description">
          Required locations are indicated with a red asterisk (<span class="asterisk">*</span>).
        </div>
        <hr class="no-margin" />
        <app-search-with-look-ahead
          [placeHolder]="'Search for a location'"
          [lookAheadItems]="viewModel.locations$ | async"
          [searchTheseProperties]="['name', 'address', 'city', 'state', 'country']"
          [disablePopper]="true"
          [nLookAheadItems]="10000"
          [outputAllItemsWhenSearchIsEmpty]="true"
          (searchText)="viewModel.connectToSearchString($event)"
          (lookAheadHits)="viewModel.connectToSearchedLocations($event)">
        </app-search-with-look-ahead>
      </div>
    </div>
    <div class="template-view-locations-container">
      <div *ngIf="!(viewModel.searchedLocations$ | async)?.length" class="empty-search-state">No locations found.</div>
      <div
        *ngFor="let location of viewModel.searchedLocations$ | async; trackBy: viewModel.trackById"
        class="location-container">
        <app-template-location-info-text
          [requiredLocationIds]="viewModel.requiredLocationIds$ | async"
          [location]="location">
        </app-template-location-info-text>
      </div>
    </div>
  </lib-sticky-body>
  <lib-sticky-footer>
    <lib-button-layout>
      <lib-button-primary (buttonClicked)="this.cancel()"> Done </lib-button-primary>
    </lib-button-layout>
  </lib-sticky-footer>
</lib-sticky-modal>
